<div class="toolbar-container">
  <app-copy-item-button></app-copy-item-button>
  <app-map-layout-change></app-map-layout-change>
  <app-map-export></app-map-export>
</div>
